import React from 'react';
import './MoreButton.css';

const MoreButtonen = () => {
  return (
    <button className="more-button">
      <span className="text">＞ See More</span>
    </button>
  );
};

export default MoreButtonen;
